<template>
  <BasePage title="Group">
    <div class="columns">
      <div class="column is-8-desktop is-offset-2-desktop">

        <section v-if="!loadingTeamData && team">
          <div class="header is-right">
            <nav class="level">
              <div class="level-item justify-content-start align-items-center" v-if="!editing">
                <h1 class="title is-1">{{ team != null ? team.name : 'Group'}}</h1>
                <span v-if="team.privacy_setting" class="tag is-medium spaced"
                :class="{'is-primary': public,
                'is-warning': closed,
                'is-danger': private}">{{ privacySettingLabel }}</span>
                <a class="button is-link" @click="editing = true" v-if="isModerator">edit</a>
              </div>
              <div v-else class="level-item justify-content-start align-items-center">
                <input @keyup.enter="save" class="input" type="text" placeholder="Group Name" v-model="editedName">
                <div class="select ml-1">
                  <select v-model="editedPrivacySetting">
                    <option v-for="name in privacy" :value="name">{{ name == 'public' ? 'open' : name }}</option>
                  </select>
                </div>
                <div class="buttons d-flex ml-1">
                  <button class="button" @click="editing = false">Cancel</button>
                  <button class="button is-primary" :class="loading && 'is-loading'" @click="save">Save</button>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Members</p>
                  <p class="title">{{team.members.length}}</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Videos</p>
                  <p class="title">{{videos.length}}</p>
                </div>
              </div>
            </nav>
          </div>
        </section>


        <Loader class='flex-start' v-if="loadingTeamData"/>


        <div class="tabs is-boxed">
          <ul>
            <li :class="activeTab === 'videos' && 'is-active'">
              <a @click="activeTab = 'videos'">
                <span>Videos</span>
              </a>
            </li>
            <li :class="activeTab === 'members' && 'is-active'">
              <a @click="activeTab = 'members'">
                <span>Members</span>
              </a>
            </li>
            <li :class="activeTab === 'data' && 'is-active'">
              <a @click="activeTab = 'data'">
                <span>Data</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="columns is-tablet">


          <!-- Videos Section -->

          <div v-if="activeTab === 'videos'" class="column">

            <section class="box">
              <h2 class="title">Shared Videos</h2>
              <section>
                <ul v-if="videos != null && videos.length > 0">

                  <article class="media" v-for="ts in videos">
                    <router-link :to="'/videos/' + ts.video.id + '/'">
                      <figure class="media-left">
                        <p class="image is-64x64">
                          <img :src="ts.video.user.avatar_url">
                        </p>
                      </figure>
                    </router-link>
                    <router-link :to="'/videos/' + ts.video.id + '/'">
                      <div class="media-content">
                        <div class="content">
                          <p>
                            <strong>{{ ts.video.user.name || ts.video.user.email }}</strong> shared the video <strong><em>{{ ts.video.title }}</em></strong>
                            <br>
                            <small>Shared on {{ ts.created_on | formatTextDate }}</small>
                          </p>
                        </div>
                      </div>

                    </router-link>
                  </article>
                </ul>
                <p v-else>No shared videos.</p>
              </section>
            </section>

          </div>

          <!-- Members Section -->

          <div v-if="activeTab === 'members'" class="column">
            <GroupModeratorPane v-if="!loadingTeamData && isModerator" :teamID="team.id" />
            <div class="columns">
              <section class="column is-8 box">
                <h2 class="title">Members</h2>
                <section v-show="!loadingTeamData">
                  <ul v-if="team != null && team.members != null && team.members.length > 0">
                    <li class="panel-block" v-for="member in team.members">
                      <p class="break-word">
                        {{ member.name || member.email }}<span v-if="member.is_coach" class="tag is-rounded is-primary">Coach</span><span v-if="member.is_group_admin" class="tag is-rounded is-warning">Admin</span>
                        <span v-if="user.id === member.id" class="tag">You</span>
                        <input
                        v-if="isModerator"
                        @click='removeUser(member.id)'
                        class='button is-small is-danger is-right'
                        type='button'
                        value='remove'
                        name='remove'/>
                      </p>
                    </li>
                  </ul>
                  <p v-else>No members.</p>
                </section>
                <Loader v-if="loadingTeamData"/>
              </section>
              <section class="column is-6 box">
                <GroupUserSearch v-if="!loadingTeamData && isModerator" :team="this.team"/>
              </section>
            </div>
          </div>

          <!-- Data Section -->

          <div v-if="activeTab === 'data'">
            <DataPane
              :name='"Brad"'
              :data="team.userdata"
            />
          </div>


        </div>

      </div>

    </div>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import GroupModeratorPane from './GroupModeratorPane.vue'
import DataPane from './DataPane.vue'
import GroupUserSearch from './GroupUserSearch.vue'

import Loader from './Loader.vue'
import { byCreatedOn } from '../sorters.js'
import { formatTextDate } from '../filters.js'

import store from '../store.js'

export default {
  name: 'Group',
  components: {
    BasePage,
    Loader,
    GroupModeratorPane,
    DataPane,
    GroupUserSearch,
  },
  filters: {
    formatTextDate,
  },
  data () {
    return {
      privacy: ['public', 'closed', 'private'],
      editing: false,
      editedPrivacySetting: 'public',
      editedName: '',
      loading: false,
      activeTab: 'videos'
    }
  },
  mounted () {
    store.dispatch('fetchTeam', this.teamID)
  },
  watch: {
    editing (newVal, _oldVal) {
      if (newVal) {
        this.editedPrivacySetting = this.team.privacy_setting
        this.editedName = this.team.name
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      store.dispatch('updateGroup', {
        id: this.team.id,
        privacy_setting: this.editedPrivacySetting,
        name: this.editedName,
      }).then(() => {
        this.editing = false
        this.loading = false
      })
    },
    removeUser (userID) {
      store.dispatch('removeUserFromTeam', { teamID: this.teamID, userID })
    },
  },
  computed: {
    teamID () {
      return parseInt(this.$route.params.id, 10)
    },
    team () {
      return store.state.teams.find(x => x.id === this.teamID)
    },
    loadingTeamData () {
      return store.state.loadingTeamData
    },
    videos () {
      if (this.team == null) {
        return []
      }
      return this.team.teamshares.sort(byCreatedOn)
    },
    user () {
      return store.state.user
    },
    public () {
      return this.team.privacy_setting === 'public'
    },
    closed () {
      return this.team.privacy_setting === 'closed'
    },
    private () {
      return this.team.privacy_setting === 'private'
    },
    isModerator () {
      if (!this.team) { return false }
      for (const i in this.team.moderators) {
        const u = this.team.moderators[i]
        if (u.id === this.user.id) {
          return true
        }
      }
      return false
    },
    privacySettingLabel () {
      return this.team.privacy_setting === 'public' ? 'open' : this.team.privacy_setting
    },
  },
}
</script>

<style lang="scss" scoped>

.header {
  margin-bottom: 25px;
}

.shared-video {
  margin-right: 10px;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1rem;
}

.margin-right {
  margin-right: 0.2rem;
}

.spaced {
  margin-left: 5px;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// Team.vue?f164b710